const Location = [
  {
    path: '/ecommerce/settings/countries',
    name: 'location',
    component: () => import(/* webpackChunkName: "location" */ '../views/LocationView.vue'),
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        {
          name: 'Countries',
          path: '/ecommerce/settings/countries',
        },
      ],
    },
    children: [
      {
        path: '/',
        name: 'countries',
        component: () => import(/* webpackChunkName: "location_countries" */ '../components/location/Country.vue'),
        meta: {
          breadCrumbs: [
            {
              name: 'Countries',
              path: '/ecommerce/settings/countries',
            },
          ],
        },
      },
      {
        path: ':country_id/states',
        name: 'country_states',
        component: () => import(/* webpackChunkName: "location_states" */ '../components/location/States.vue'),
        meta: {
          requiresAuth: true,
          breadCrumbs: [
            {
              name: 'Countries',
              path: '/ecommerce/settings/countries',
            },
            {
              name: 'Sates',
              path: '/ecommerce/settings/countries/:country_id/states',
            },
          ],
        },
      },
    ],
  },
];

export default Location;
